// @flow
import type { Country } from '../country';
import { getPhoneNumberNormalizerWithLength } from '../../customer-form/get-phone-number-normalizer';

const GHANA: Country = {
  code: 'gh',
  customerForm: {
    phoneNumber: {
      normalizer: getPhoneNumberNormalizerWithLength(20),
    },
  },
};

export default GHANA;
